export default "__VITE_ASSET__BbEKWDgY__"